import { Modal } from "antd";

const DemoVideoModal = ({ demoVideoModal, onChangeDemoVideo, demoVideo }) => {
  return (
    <Modal
      open={demoVideoModal}
      closable={true}
      centered
      onCancel={() => onChangeDemoVideo(false)}
      width={"80%"}
      footer={null}
      className="demo-video-modal-box"
    >
      <video autoPlay controls className="demo-video">
        <source src={demoVideo} type="video/mp4" />
      </video>
    </Modal>
  );
};

export default DemoVideoModal;
